<template>
  <div>
    <el-dialog
      ref="viewDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="abow_dialog h680_dialog"
      width="1100px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
    >
      <el-form
        ref="dialogViewForm"
        :model="dialogViewForm"
        class="add-edit-view-form"
        @submit.native.prevent
      >
        <div class="modal-box">
          <h3 class="modal-title">
            基础信息
          </h3>
          <div class="modal-row-box">
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item style="margin-top: 10px;">
                  <el-avatar
                    shape="square"
                    :size="90"
                    fit="fill"
                    :src="dialogViewForm.smallHeadImgUrl"
                    @click.native="handleShowPreviewImage"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item label="成员微信号">
                  <el-input
                    v-model="dialogViewForm.userName"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="昵称">
                  <el-input
                    v-model="dialogViewForm.nickname"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="所在微信群">
                  <el-input
                    v-model="dialogViewForm.groupNames"
                    disabled
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item label="零售户区域">
                  <el-input
                    v-model="dialogViewForm.storeArea"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="零售户地址">
                  <el-input
                    v-model="dialogViewForm.storeAddress"
                    disabled
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item label="零售户店名">
                  <el-input
                    v-model="dialogViewForm.certificatedStoreName"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="零售户专卖证号">
                  <el-input
                    v-model="dialogViewForm.storeCertificateNo"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="零售户档位">
                  <el-input
                    v-model="dialogViewForm.storeLevel"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="零售户维护情况">
                  <el-input
                    v-model="dialogViewForm.storeStatusValue"
                    disabled
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item label="问卷用户ID">
                  <el-input
                    v-model="dialogViewForm.questionnaireUid"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="问卷用户昵称">
                  <el-input
                    v-model="dialogViewForm.questionnaireNickname"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="问卷用户填写市场">
                  <el-input
                    v-model="dialogViewForm.questionnaireMarket"
                    disabled
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item label="问卷填写门店名称">
                  <el-input
                    v-model="dialogViewForm.questionnaireStoreName"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="问卷填写专卖证号">
                  <el-input
                    v-model="dialogViewForm.questionnaireCertificateNo"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="问卷填写本香门店绑定手机号">
                  <el-input
                    v-model="dialogViewForm.questionnaireBxPhone"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="问卷填写门店档位">
                  <el-input
                    v-model="dialogViewForm.questionnaireStoreLevel"
                    disabled
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item label="睿零售注册用户OPENID">
                  <el-input
                    v-model="dialogViewForm.wxOpenId"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="睿零售用户姓名">
                  <el-input
                    v-model="dialogViewForm.appUserName"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="睿零售用户联系电话">
                  <el-input
                    v-model="dialogViewForm.appUserPhone"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="睿零售用户专卖证号">
                  <el-input
                    v-model="dialogViewForm.appUserCertificateNo"
                    disabled
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-form>

      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>

    <!-- 查看头像大图 -->
    <el-image-viewer
      v-if="showImageViewer"
      :z-index="5000"
      :on-close="() => {showImageViewer=false}"
      :url-list="previewImageList"
      :initial-index="0"
      class="image-viewer"
    />
  </div>
</template>
<script>
// dialog拖拽Mixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 微信联系人API
import { viewWeChatContactApi } from '@/api/v2/weChatContact'

export default {
  components: {
    'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer')
  },
  mixins: [dialogDragMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      dialogViewForm: {},
      // 预览图片
      showImageViewer: false,
      previewImageList: [],
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        let _this = this;
        _this.showImageViewer = false;
        _this.previewImageList = [];

        _this.dialogViewForm = {};
        _this.loadWeChatContactData();

        _this.$nextTick(() => { })
      }
    }
  },
  methods: {
    // 加载数据
    loadWeChatContactData () {
      let _this = this;
      viewWeChatContactApi({ id: _this.dataId }).then((response) => {
        const { data } = response;
        _this.dialogViewForm = data;

        if (data.bigHeadImgUrl) {
          _this.previewImageList.push(data.bigHeadImgUrl);
        }
      })
    },
    // 预览图片
    handleShowPreviewImage () {
      let _this = this;
      _this.showImageViewer = true;
    },

    modalClose () {
      let _this = this;
      _this.$emit('update:dialogVisible', false)
    },
  }
}
</script>
<style lang="scss"  scoped>
::v-deep .el-image-viewer__img {
  transform: scale(0.6) !important;
}
</style>
